export enum OtpNature {
	RESET_PASSWORD = 3,
	UPDATE_EMAIL = 4,
	UPDATE_PHONE = 5,
	WEB_LOGIN = 6,
}
